import { eventBus } from '@tools/event-bus';
import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import StickyMenu from './navUserMobile/StickyMenu.vue';

export const navUserMobile = () => {
  createApp(StickyMenu)
    .use(VueClickAway)
    .mount('#nav-user-mobile');

  eventBus.addEventListener('nav-user-mobile-hidden', () => {
    document.getElementById('nav-user-mobile')?.classList.toggle('nav-mobile--hidden');
  });
};
